import React, { useState } from 'react';
import {
  Title,
  Grid,
  Col,
  Button,
  Card,
  CardHeader,
  CardContent,
  Icon,
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter,
  Loader,
} from '@common/components';
import { useAppDispatch, useAppSelector } from '@app/hooks/index';

import {
  selectErrorModal,
  selectLoadingModal,
  setErrorModal,
  setLoadingModal,
} from '@app/slices/modals';
import { faWarning } from '@fortawesome/free-solid-svg-icons';
import { AlertModal } from '@app/components/AlertModal';
import modalClasses from './ModalSampleView.module.scss';

export default function ModalSampleView() {
  const [visibleBasic, setVisibleBasic] = useState();
  const [visibleIcon, setVisibleIcon] = useState();
  const [visibleLoader, setVisibleLoader] = useState();

  const dispatch = useAppDispatch();
  const reduxLoading = useAppSelector(selectLoadingModal);
  const reduxError = useAppSelector(selectErrorModal);
  return (
    <div className={modalClasses.grid}>
      <Title type="h1">Modal demo</Title>
      <Card className={modalClasses.section}>
        <CardHeader>
          <Title type="h3">Basic</Title>
        </CardHeader>
        <CardContent>
          <Grid gutter={20}>
            <Col flex justify="center" xs={6} sm={4}>
              <Button
                variant="flat"
                color="primary"
                onClick={() => setVisibleBasic(true)}
              >
                Open Basic Modal
              </Button>
            </Col>
            <Col flex justify="center" xs={6} sm={4}>
              <Button
                variant="flat"
                color="error"
                onClick={() => setVisibleIcon(true)}
              >
                Open Icon Modal
              </Button>
            </Col>
            <Col flex justify="center" xs={6} sm={4}>
              <Button
                variant="flat"
                color="accent"
                onClick={() => setVisibleLoader(true)}
              >
                Open Loader Modal
              </Button>
            </Col>
            <Col flex justify="center" xs={6} sm={4}>
              <Button
                variant="flat"
                color="primary"
                onClick={() => dispatch(setLoadingModal(true))}
              >
                Open Loading Modal Reducer
              </Button>
            </Col>
            <Col flex justify="center" xs={6} sm={4}>
              <Button
                variant="flat"
                color="error"
                onClick={() => dispatch(setErrorModal(true))}
              >
                Open Error Modal Reducer
              </Button>
            </Col>
          </Grid>
        </CardContent>
      </Card>

      <Modal
        closeOnClickOutside
        onClose={() => setVisibleBasic(false)}
        visible={visibleBasic}
      >
        <ModalHeader>
          <Title>Titulo</Title>
        </ModalHeader>
        <ModalContent className={modalClasses.center}>Información</ModalContent>
        <ModalFooter>
          <Button variant="flat" onClick={() => setVisibleBasic(false)}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        closeOnClickOutside
        onClose={() => setVisibleIcon(false)}
        visible={visibleIcon}
      >
        <ModalHeader>
          <Title>Titulo</Title>
        </ModalHeader>
        <ModalContent className={modalClasses.center}>
          <Icon icon={faWarning} size="6x" color="error" />
          <div>¿Seguro que desea eliminar el registro?</div>
        </ModalContent>
        <ModalFooter>
          <Button variant="flat" onClick={() => setVisibleIcon(false)}>
            Aceptar
          </Button>
          <Button
            variant="flat"
            color="error"
            onClick={() => setVisibleIcon(false)}
          >
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        closeOnClickOutside
        onClose={() => setVisibleLoader(false)}
        visible={visibleLoader}
      >
        <ModalHeader>
          <Title type="h3">Cargando...</Title>
        </ModalHeader>
        <ModalContent className={modalClasses.center}>
          <Loader size="big" />
        </ModalContent>
      </Modal>

      <Modal
        closeOnClickOutside
        onClose={() => dispatch(setLoadingModal(false))}
        visible={reduxLoading}
      >
        <ModalHeader>
          <Title type="h3">Cargando...</Title>
        </ModalHeader>
        <ModalContent className={modalClasses.center}>
          <Loader size="big" />
        </ModalContent>
      </Modal>

      <AlertModal
        show={reduxError}
        type="error"
        title="genericErrorTitle"
        text="Se ha producido un error de validación"
      />
    </div>
  );
}
